

































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import ProductAPI from '@/services/ProductAPI';
import UserAPI from '@/services/UserAPI';

import Product from '@/types/Product';

import ImageSlider from '@/components/ImageSlider.vue';
import Util from '@/util/Util';

export default Vue.extend({
    name: 'Product',

    components: {
        ImageSlider
    },

    props: {
        productId: {
            type: String,
            default: ''
        }
    },

    watch: {
        productId(newProductId: string, oldProductId: string) {
            Util.updateHeaders(this.getLanguage(this.productById(newProductId).productName), this.getLanguage(this.productById(newProductId).productDescription), this.productById(newProductId).iconImage.url);
        }
    },

    created() {
        if (this.productId) {
            Util.updateHeaders(this.getLanguage(this.productById(this.productId).productName), this.getLanguage(this.productById(this.productId).productDescription), this.productById(this.productId).iconImage.url);
        }
    },

    computed: {
		...mapState(['language']),

        ...mapGetters(['isCollected', 'isLiked', 'isUserAdmin', 'isSignedIn', 'productById', 'getLanguage'])
    },

    methods: {
        list: (product: Product): string => {
            return Product.listProductionPeriod(product.productionPeriods);
        },

        editProduct(): void {
            this.$router.push(`/${this.language}/admin/products/${this.productId}`);
        },

        toggleProductCollected(productId: string) {

            if (!this.isSignedIn) {
                alert(this.$text('signInToAddToCollection'));
                return;
            }

            const handleResponse = (response: AxiosResponse) => {
                    this.$store.commit('setUser', response.data.user);
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        alert(error.response.data.message);
                    }
                };

            if (this.isCollected(productId)) {
                UserAPI
                    .deleteCollect(productId)
                    .then(handleResponse)
                    .catch(handleError);
            } else {
                UserAPI
                    .postCollect(productId)
                    .then(handleResponse)
                    .catch(handleError);
            }

        },

        toggleProductLiked(productId: string) {
            this.toggleProductLikeUser(productId);
        },

        toggleProductLikeUser(productId: string) {
            const handleResponse = (response: AxiosResponse) => {
                    this.$store.commit('setUser', response.data.user);
                    this.loadProducts();
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        alert(error.response.data.message);
                    }
                };

            if (this.isLiked(productId)) {
                UserAPI
                    .deleteLike(productId)
                    .then(handleResponse)
                    .catch(handleError);
            } else {
                UserAPI
                    .postLike(productId)
                    .then(handleResponse)
                    .catch(handleError);
            }
        },

        loadProducts(): void {
            ProductAPI
                .get()
                .then((axiosResponse: AxiosResponse) => this.$store.commit('setProducts', axiosResponse.data))
                .catch((error: AxiosError) => error);
        },

        splitByNewLine(text: string): string[] {
            return text ? text.split(/\r\n|\n|\r/) : [];
        }
    }
});
